// extracted by mini-css-extract-plugin
export default {"emptySection":"styles_emptySection__BCYID","icon":"styles_icon__ckMBe","heading":"styles_heading__tsANf","para":"styles_para__RGiYm"};